import AuthorizeNetLogo from "@/assets/img/payment-providers/authorize-net-logo.png";
import AdyenLogo from "@/assets/img/payment-providers/adyen-logo.png";
import ManualLogo from "@/assets/img/payment-providers/manual-logo.png";
import NMILogo from "@/assets/img/payment-providers/nmi-logo.webp";
import PayPalLogo from "@/assets/img/payment-providers/paypal-logo.png";
import SquareLogo from "@/assets/img/payment-providers/square-logo.png";
import StripeLogoBlue from "@/assets/img/payment-providers/stripe-logo-blue.png";

export const IMAGE_URL_SUFFIX = {
  AUTHORIZE_NET: "authorize-net",
  NMI: "nmi",
  MANUAL: "manual",
  PAYPAL: "paypal",
  SQUARE: "square",
  STRIPE: "stripe",
  ADYEN: "adyen",
} as const;

/**
 * Returns a local payment provider logo if the image URL matches a known provider, otherwise returns the original URL.
 * @param img - Image URL or path from the API (e.g. "/images/stripe-logo-blue.png")
 * @returns Local asset URL or the original img string
 */
export const loadImages = (img: string): string => {
  if (!img || typeof img !== "string") return img;
  const lower = img.toLowerCase();
  if (lower.includes(IMAGE_URL_SUFFIX.AUTHORIZE_NET)) return AuthorizeNetLogo;
  if (lower.includes(IMAGE_URL_SUFFIX.NMI)) return NMILogo;
  if (lower.includes(IMAGE_URL_SUFFIX.MANUAL)) return ManualLogo;
  if (lower.includes(IMAGE_URL_SUFFIX.PAYPAL)) return PayPalLogo;
  if (lower.includes(IMAGE_URL_SUFFIX.SQUARE)) return SquareLogo;
  if (lower.includes(IMAGE_URL_SUFFIX.STRIPE)) return StripeLogoBlue;
  if (lower.includes(IMAGE_URL_SUFFIX.ADYEN)) return AdyenLogo;
  return img;
};
